
import { useRouteError, isRouteErrorResponse } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function ErrorBoundary() {
    const { t } = useTranslation();
    const error = useRouteError();
    console.error(error);

    let errorMessage = t('common.unexpected_error', 'An unexpected error has occurred.');
    let errorStatus = t('common.error', 'Error');

    if (isRouteErrorResponse(error)) {
        // error is type `ErrorResponse`
        errorMessage = error.statusText || error.data?.message || t('common.page_not_found', 'Page not found');
        errorStatus = `${error.status}`;
    } else if (error instanceof Error) {
        errorMessage = error.message;
    } else if (typeof error === 'string') {
        errorMessage = error;
    }

    return (
        <div className="flex flex-col items-center justify-center min-h-screen bg-gray-50 text-gray-800 p-6">
            <div className="bg-white p-8 rounded-xl shadow-lg max-w-md w-full text-center">
                <h1 className="text-4xl font-bold text-red-500 mb-4">{errorStatus}</h1>
                <p className="text-lg font-medium mb-6">{t('common.error_oops', 'Oops! Something went wrong.')}</p>
                <p className="text-gray-600 italic mb-8 break-words p-4 bg-gray-100 rounded-lg text-sm font-mono">
                    {errorMessage}
                </p>
                <a href="/" className="px-6 py-3 bg-primary text-black rounded-lg hover:bg-primary/90 transition-colors font-semibold">
                    {t('common.go_home', 'Go back home')}
                </a>
            </div>
        </div>
    );
}
